<template>
  <div>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInLeft"
      leave-active-class="animated fadeOutRight"
    >
      <div
        class="side-nav"
        v-if="isShowMiniMenu"
      >
        <ul>
          <!-- <li>
            <md-icon
              class="fa fa-weixin"
              style="color:#35D467"
            >
            </md-icon>
            <div class="detail">
              <div class="detail-logo">
                <img src="@/assets/logo.png" />
              </div>
              <div class="triangle">
              </div>
              <img
                src="@/assets/yuwenquan.jpg"
                width="120"
              />
              <p>微信公众号</p>
            </div>
          </li>
          <li>
            <md-icon class="fa fa-qrcode">
            </md-icon>
            <div class="detail">
              <div class="detail-logo">
                <img src="@/assets/logo.png" />
              </div>
              <div class="triangle">
              </div>
              <img
                src="@/assets/yuwenquan.jpg"
                width="120"
              />
              <p>微信下单</p>
            </div>
          </li>
          <li @click="showMoreMenu">
            <md-icon class="fa fa-bars">
              <md-tooltip :md-direction="direction">更多菜单</md-tooltip>
            </md-icon>
          </li> -->
          <li @click="scrollTop">
            <md-icon class="fa fa-hand-o-up">
              <md-tooltip :md-direction="direction">返回顶部</md-tooltip>
            </md-icon>
          </li>
        </ul>
      </div>
    </transition>
    <transition
      name="custom-classes-transition"
      enter-active-class="animated fadeInRightBig"
      leave-active-class="animated fadeOutRight"
    >
      <div
        class="side-complete-nav"
        v-if="!isShowMiniMenu"
      >
        <ul>
          <li>
            <md-icon
              class="fa fa-user-o"
              style="color:#35D467"
            >
            </md-icon>
          </li>
          <li class="icon_badge">
            <md-badge
              md-content="100"
              md-dense
            >
              <md-icon
                class="fa fa-shopping-cart"
                style="color:#35D467"
              >
              </md-icon>
              <md-tooltip md-direction="left">购物车</md-tooltip>
            </md-badge>
          </li>
          <li class="icon_badge">
            <md-badge
              md-content="1"
              md-dense
            >
              <md-icon
                class="fa fa-commenting-o"
                style="color:#35D467"
              >
              </md-icon>
              <md-tooltip md-direction="left">我的消息</md-tooltip>
            </md-badge>
          </li>
          <li>
            <md-icon class="fa fa-qrcode">
            </md-icon>
          </li>
          <li @click.native="showMoreMenu">
            <md-icon class="fa fa-bars">
              <md-tooltip :md-direction="direction">更多菜单</md-tooltip>
            </md-icon>
          </li>
          <li @click.native="scrollTop">
            <md-icon class="fa fa-hand-o-up">
              <md-tooltip :md-direction="direction">返回顶部</md-tooltip>
            </md-icon>
          </li>
        </ul>
        <ul>
          <li>
            <md-icon
              class="fa fa-weixin"
              style="color:#35D467"
            >
            </md-icon>
          </li>
          <li>
            <md-icon class="fa fa-qrcode">
            </md-icon>
          </li>
          <li @click="showMiniMenu">
            <md-icon class="fa fa-minus">
              <md-tooltip :md-direction="direction">缩小菜单</md-tooltip>
            </md-icon>
          </li>
          <li @click="scrollTop">
            <md-icon class="fa fa-hand-o-up">
              <md-tooltip :md-direction="direction">返回顶部</md-tooltip>
            </md-icon>
          </li>
        </ul>
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  data() {
    return {
      direction: 'left',
      isShowMiniMenu: true
    }
  },
  methods: {
    showMoreMenu() {
      this.isShowMiniMenu = false;
    },
    showMiniMenu() {
      this.isShowMiniMenu = true;
    },
    scrollTop() {
      var scrollToptimer = setInterval(function () {
        var top = document.body.scrollTop || document.documentElement.scrollTop;
        var speed = top / 10;
        if (document.body.scrollTop != 0) {
          document.body.scrollTop -= speed;
        } else {
          document.documentElement.scrollTop -= speed;
        }
        if (top == 0) {
          clearInterval(scrollToptimer);
        }
      }, 20);
    }
  }
}
</script>

<style lang="scss">
$boxShadow: 0 3px 1px -2px rgba(0, 0, 0, 0.2), 0 2px 2px 0 rgba(0, 0, 0, 0.14),
  0 1px 5px 0 rgba(0, 0, 0, 0.12);

$goldenColor: #dc9b04;
.side-nav {
  width: 40px;
  position: fixed;
  // min-height: 190px;
  right: 20px;
  bottom: 40px;
  z-index: 999;
  box-shadow: $boxShadow;
  ul {
    list-style: none;
    padding: 0;
    margin: 0;
    z-index: 999;
    background: #ffffff;
    li {
      width: 40px;
      height: 50px;
      display: flex;
      align-items: center;
      border-bottom: 1px solid #eee;
      cursor: pointer;
      position: relative;
      &:hover {
        background: #eee;
        color: #000;
      }
      &:hover .detail {
        display: block;
      }
      .detail {
        display: none;
        animation-duration: 1s;
        animation-name: fadeInLeft;
        position: absolute;
        width: 150px;
        top: 0px;
        left: -165px;
        box-shadow: $boxShadow;
        .detail-logo {
          position: absolute;
          width: 70px;
          top: -40px;
          left: -40px;
        }
        .triangle {
          position: absolute;
          top: 15px;
          right: -9px;
          display: inline-block;
          display: inline;
          background: url("../../assets/base.png");
          zoom: 1;
          width: 9px;
          height: 30px;
          background-position: -10px 0;
        }
        p {
          padding: 0px;
          margin: 0px;
        }
      }
    }
  }
}
.side-complete-nav {
  position: fixed;
  z-index: 999;
  top: 0;
  right: 0;
  width: 40px;
  background: #000;
  bottom: 0;
  color: #fff;
  display: flex;
  justify-content: space-between;
  flex-direction: column;
  ul {
    padding: 0;
    margin: 0;
    list-style: none;
    &:last-child {
      border-top: 1px dashed #ccc;
    }
    li {
      width: 40px;
      height: 50px;
      display: flex;
      align-items: center;
      cursor: pointer;
      position: relative;
      i {
        color: $goldenColor !important;
      }
      &:hover {
        background: #dedede;
        color: #000;
      }
      &.icon_badge {
        display: flex;
        justify-content: center;
      }
    }
  }
}
</style>

